import React from 'react';
import { FinancialRiskFlagCard } from './FinancialRiskFlagCard';
import type { FinancialRiskFinding } from '../../services/api';

interface FinancialRiskFlagsListProps {
  findings: FinancialRiskFinding[];
  selectedSectionKey: string | null;
  onCompare?: (finding: FinancialRiskFinding) => void;
}

export const FinancialRiskFlagsList: React.FC<FinancialRiskFlagsListProps> = ({
  findings,
  selectedSectionKey,
  onCompare,
}) => {
  const filteredFindings = selectedSectionKey
    ? findings.filter(
        (f) => `${f.articleNumber}-${f.sectionNumber}` === selectedSectionKey
      )
    : findings;

  if (filteredFindings.length === 0) {
    return (
      <div className="text-center py-8 text-gray-400" data-testid="no-flags">
        {selectedSectionKey
          ? 'No flags found in the selected section.'
          : 'Select a section to view its flags.'}
      </div>
    );
  }

  return (
    <div className="space-y-3" data-testid="flags-list">
      <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wide">
        Flags ({filteredFindings.length})
      </h3>
      {filteredFindings.map((finding) => (
        <FinancialRiskFlagCard
          key={finding.id}
          finding={finding}
          onCompare={onCompare}
        />
      ))}
    </div>
  );
};
